import request from '@/utils/request'
const apiPath = '/sys/tools'
import qs from 'qs'
const sysToolsApi = {
  /**
   * 营业执照识别 ORC
   */
  bizLicenseOCR(data) {
    return request.post(`${apiPath}/bizLicenseOCR`, data)
  },
  /**
   * 身份证识别 OCR
   */
  idCardOCR(data) {
    return request.post(`${apiPath}/idCardOCR`, data)
  },
  sendAuxToYongYouById(data) {
    return request.post(`${apiPath}/sendAuxToYongYouById`, data, { isFormData: 1 })
  },
  toYongYou(data) {
    return request.post(`${apiPath}/toYongYou`, data, { isFormData: 1 })
  },
  sendOrderToYongYouAll(data) {
    return request.post(`${apiPath}/sendOrderToYongYouAll`, data)
  },
  // 推送订单到用友,现在是对接的聚水潭
  sendOrder(params) {
    const data = qs.stringify(params, { arrayFormat: 'repeat' });
    return request.post(`${apiPath}/sendOrder`, data, {
      "headers": {
        "Content-Type": "application/x-www-form-urlencoded",
      }
    })
  },
  refreshYongYouToken(query) {
    return request.get(`${apiPath}/refreshYongYouToken`, { params: query })
  },
  getMarketingOrgan(data) {
    return request.post(`${apiPath}/getMarketingOrgan`, data, { isFormData: 1 })
  },
  /**
   * 获取用户信息列表
   */
  userInfoList(query) {
    return request.get(`${apiPath}/tee/userInfoList`, { params: query })
  },
}
export default sysToolsApi
